import querystring from 'querystring';

function getParam(name) {
    const query = querystring.parse(window.location.search.slice(1));
    return query[name];
}

function setParam(name, value) {
    if (!value) {
        return;
    }
    const url = new URL(window.location);
    const query = querystring.parse(url.search.slice(1));
    query[name] = value;
    url.search = querystring.stringify(query);
    window.history.replaceState(null, null, url.toString());
}

// Syncs the deeplink with the specified model and property name
export function deepLinkModel(model, prop) {
    model.$watch(state => state[prop], value => setParam(prop, value));
    return getParam(prop) || model[prop];
}
